import {
  ActionIcon, ConfirmModal, ICON_TRASH_CAN_OUTLINE, Portal, useModal,
} from '@doveit/bricks';
import React from 'react';
import { PropertyUnit } from '../../../providers/api/dtos';

interface ChildFnProps {
  openDeleteModal: VoidFunction,
}

export interface DeletePropertyUnitActionProps extends React.AriaAttributes {
  propertyUnit: PropertyUnit,
  onSuccess?: (deletedPropertyUnit: PropertyUnit) => Promise<void> | void,
  children?: (childFnProps: ChildFnProps) => React.ReactNode,
}

const DeletePropertyUnitAction: React.FC<DeletePropertyUnitActionProps> = ({
  propertyUnit,
  onSuccess,
  children,
  ...rest
}) => {
  const modal = useModal();
  const [isSaving, setIsSaving] = React.useState(false);

  const handleDelete = React.useCallback(async () => {
    setIsSaving(true);

    await onSuccess?.(propertyUnit);

    modal.close();

    setIsSaving(false);
  }, [modal, onSuccess, propertyUnit]);

  return (
    <>
      {children
        ? children({
          openDeleteModal: () => modal.open(),
        })
        : (
          <ActionIcon
            icon={{ path: ICON_TRASH_CAN_OUTLINE }}
            label="Elimina"
            aria-label="Pulsante per eliminare l'unità immobiliare"
            size="S"
            onClick={() => modal.open()}
            {...rest}
          />
        )}
      <Portal>
        <ConfirmModal
          variant="critical"
          title="Conferma eliminazione unità immobiliare"
          aria-label="Modale per eliminare l'unità immobiliare"
          isOpen={modal.isOpen}
          loading={isSaving}
          onConfirm={handleDelete}
          onAbort={() => modal.close()}
          dismissable={false}
        >
          Confermando l&apos;operazione, l&apos;unità immobiliare sarà eliminata e i dati non potranno essere recuperati.
        </ConfirmModal>
      </Portal>
    </>
  );
};

export default DeletePropertyUnitAction;
